import { render, staticRenderFns } from "./budgetFreezingComponent.vue?vue&type=template&id=ccc7f32c&scoped=true&"
import script from "./budgetFreezingComponent.vue?vue&type=script&lang=js&"
export * from "./budgetFreezingComponent.vue?vue&type=script&lang=js&"
import style0 from "./budgetFreezingComponent.vue?vue&type=style&index=0&id=ccc7f32c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccc7f32c",
  null
  
)

export default component.exports